import { HttpClient } from '@adapters/HttpClient';
import {
  CategoryDetailResponse,
  CreateCategoryPayload,
  ProductCategory,
  UpdateCategoryPayload,
} from '../models/ProductCategory';

export class ProductCategoriesApiAdapter {
  constructor(private httpClient: HttpClient) {}

  async getAll(filters?: { name?: string }): Promise<ProductCategory[]> {
    const params = filters?.name ? { name: filters.name } : undefined;
    const raw = await this.httpClient.get<ProductCategory[] | { data: ProductCategory[] }>('/categories', params);
    const list = Array.isArray(raw) ? raw : (raw.data ?? []);
    return list;
  }

  async getById(id: number): Promise<ProductCategory> {
    const response = await this.httpClient.get<CategoryDetailResponse>(`/categories/${id}`);
    return response.data;
  }

  async create(payload: CreateCategoryPayload): Promise<ProductCategory> {
    const response = await this.httpClient.post<CategoryDetailResponse>('/categories', payload);
    return response.data;
  }

  async update(id: number, payload: UpdateCategoryPayload): Promise<ProductCategory> {
    const response = await this.httpClient.put<CategoryDetailResponse>(`/categories/${id}`, payload);
    return response.data;
  }

  async delete(id: number): Promise<void> {
    return this.httpClient.delete<void>(`/categories/${id}`);
  }
}
